import { Col, Typography } from 'antd';
import React from 'react';

import { PostMessage } from '@common/components';
import { SupplierStatusTypes } from '@common/graphql';
import { SupplierActivationLogForCurrentOrganizationType } from '@institutions/graphql';

const { Title } = Typography;

type Props = {
  status: SupplierStatusTypes;
  activationLog: SupplierActivationLogForCurrentOrganizationType;
};

// @TODO: kill this component when the History component is implemented
export function SuppliersManagementViewDrawerInvitationMessage({
  status,
  activationLog,
}: Props) {
  const comment = {
    message: activationLog?.lastComment?.contentAsText,
    name: activationLog?.createdBy.name,
    time: activationLog?.createdAt,
  };

  const statusModel = {
    PENDING_SIGNUP: {
      title: 'Invite Note',
      ...comment,
    },
    INVITED: {
      title: 'Invite Note',
      ...comment,
    },
    DECLINED: {
      title: 'Decline Reason',
      ...comment,
    },
    PENDING_ACTIVATION: {
      title: 'Accept Reason',
      ...comment,
    },
    ACTIVE: null,
    AVAILABLE: null,
  }[status];

  if (!statusModel?.message || !statusModel?.name || !statusModel?.time) {
    return <></>;
  }

  const { title, message, name, time } = statusModel;

  return (
    <Col span={24}>
      <Title level={3}>{title}</Title>
      <PostMessage message={message} name={name} time={time} />
    </Col>
  );
}
